<template>
  <div class="sign">
    <div class="left">
      <img class="logo" src="../../../assets/img/logo-new.png" alt />
    </div>
    <div class="right">

      <div class="btn-return" @click="$router.push({ name: 'signIn' })"> <i class="el-icon-arrow-left"></i>
        <I18Lang id="user23" defaultText="" />
      </div>

      <div class="sign-main">
        <!-- <div class="sign-tap">
          <div class="tap-item" :class="signType===0?'active':''" @click="tapSignType(0)">邮箱注册帐户</div>
          <div class="tap-item" :class="signType===1?'active':''" @click="tapSignType(1)">手机注册帐户</div>
        </div> -->

        <EmailReg  />
        <!-- <PhoneReg v-else/> -->
      </div>

    </div>
  </div>
</template>

<script>
import EmailReg from './emailReg.vue'

export default {
  data () {
    return {
      signType: 1
    }
  },
  methods: {
    tapSignType (type) {
      this.signType = type
    }
  },
  components: {
    EmailReg
  }
}
</script>

<style scoped lang="scss">
.sign {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  .left {
    flex: 0 0 50%;
    height: 100%;
    background: url('../../../assets/img/sign/bg-reg.png') no-repeat center / auto 100%;

    .logo {
      width: 200px;
      position: absolute;
      top: 67px;
      left: 78px;
    }
  }

  .right {
    flex: 0 0 50%;
    height: 100%;
    overflow-y: auto;
    padding-top: 48px;
    padding-bottom: 57px;

    .account-id {
      color: #00CCFF;
    }

    .btn-return {
      font-size: 20px;
      font-family: Arial;
      font-weight: bold;
      color: #00CCFF;
      line-height: 37px;
      margin-left: 48px;
      display: inline-flex;
      align-items: center;
      margin-bottom: 32px;
      cursor: pointer;

      i {
        width: 56px;
        height: 56px;
        border: 1px solid #143c4c;
        border-radius: 50%;
        color: #00CCFF;
        text-align: center;
        line-height: 56px;
        margin-right: 20px;
        font-weight: bold;
      }
    }

    .sign-main{
      text-align: center;
    }

    .sign-tap {
      text-align: center;
      display: inline-block;
      margin-bottom: 30px;

      .tap-item {
        display: inline-block;
        font-size: 16px;
        color: rgba(1, 178, 245, 0.5);
        border-bottom: 1px solid rgba(1, 178, 245, 0.5);
        cursor: pointer;
        padding: 15px 30px;
        &.active {
          color: #00CCFF;
          border-bottom: 1px solid #00CCFF;
        }
      }
    }
  }
}
</style>
